import styled from '@emotion/styled';
import ToggleStandardPlans from './Plans/ToggleStandardPlans.Container';

const Wrapper = styled.div`
  min-width: 560px;
  padding-top: 16px;
  padding-bottom: 16px;
`;

const BuildPlanModalContentView = (props: any) => (
  <Wrapper>
    <ToggleStandardPlans {...props} />
  </Wrapper>
);

export default BuildPlanModalContentView;
